import React from 'react';
import { UserInfo } from '../../api/admin';
import Button from '../ui/Button';
import Modal from '../ui/Modal';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  user: UserInfo | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ isOpen, user, onClose, onConfirm }) => {
  if (!user) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete User" maxWidth="max-w-md">
      <div className="mb-6">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <span className="material-icons text-red-600" style={{ fontSize: '40px' }}>
              warning
            </span>
          </div>
          <div className="ml-4">
            <h4 className="text-lg font-medium text-slate-900">Are you sure?</h4>
            <p className="text-sm text-slate-600">
              You are about to delete the user "<span className="font-semibold">{user.username}</span>". This action cannot be undone.
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete User
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
